export const baseUrl = `https://dc-verification-api.herokuapp.com`;
